'use strict';

/* globals Modernizr */

const _ = require('lodash');

const LoginFormController = function ($rootScope, $scope, $stateParams, $timeout, AnalyticsService, sbAuth, IntercomService,  LoginService, RoutingUtil, SocialLoginService) {

  const vm = this;
  vm.error = '';
  vm.inputs = ['email', 'password'];
  vm.isTouch = typeof Modernizr !== 'undefined' && Modernizr.touch;
  vm.loginButtonText = 'Log in';
  vm.menuActive = false;
  vm.redirectLocation = $stateParams.location;
  vm.spinnerMessage = 'Requesting Access';
  vm.text = 'Invalid username or password';
  vm.data = {
    email: '',
    password: '',
    rememberme: false
  };

  const sendAnalytics = (authType) => {

    AnalyticsService.track('[CORE] Login', 'Log in with ' + authType, {});
  };

  const onAuthSuccess = () => {

    IntercomService.shutdown();
  };

  const onAuthError = (res) => {

    vm.loginButtonText = 'Log in';
    vm.error = res.data.error.friendlyMessage;
  };

  vm.login =  _.debounce(() => {

    sendAnalytics('Email');
    vm.loginButtonText = 'Loading...';
    sbAuth.authenticate(vm.data, onAuthSuccess, onAuthError);
  }, 50);

  vm.forgotPassword = () => {

    RoutingUtil.redirectTo('forgot-password');
  };

  vm.openChat = () => {

    IntercomService.show();
  };

  vm.googleLogin = () => {

    sendAnalytics('Google - Request');
    vm.loginButtonText = 'Loading...';
    SocialLoginService.googleAuth()
      .catch(() => {

        vm.error = vm.text = SocialLoginService.errorMessage;
      })
      .then((result) => {

        if (!result) { // Login was cancelled
          vm.loginButtonText = 'Log in';
          $scope.$apply();
        }
        else {
          sendAnalytics('Google - Success');
        }
      });
  };

  vm.fbLogin = () => {

    sendAnalytics('Facebook - Request');
    vm.loginButtonText = 'Loading...';
    SocialLoginService.facebookAuth()
      .catch(() => {

        vm.error = vm.text = SocialLoginService.errorMessage;
      })
      .then((result) => {

        if (!result) { // Login was cancelled
          vm.loginButtonText = 'Log in';
          $scope.$apply();
        }
        else {
          sendAnalytics('Facebook - Success');
        }
      });
  };

  if ($stateParams.token) {
    vm.showSpinner = true;
    vm.data.token = $stateParams.token;
    vm.login();
  }

  $timeout(() => {

    SocialLoginService.isGoogleLoggedIn()
      .then((loggedIn) => {

        if (loggedIn) {
          vm.loginButtonText = 'Loading...';
          SocialLoginService.googleAuth(null, true);
        }
      });

    SocialLoginService.isFacebookLoggedIn()
      .then((loggedIn) => {

        if (loggedIn) {
          vm.loginButtonText = 'Loading...';
          SocialLoginService.facebookAuth(null, true);
        }
      });
  }, 500); // Add a small timeout to prevent clients from double initialization

  vm.toggleMenu = () => {

    vm.menuActive = !vm.menuActive;
  };
};

LoginFormController.$inject = [
  '$rootScope', '$scope', '$stateParams', '$timeout', 'AnalyticsService', 'sbAuth', 'IntercomService', 'LoginService', 'RoutingUtil', 'SocialLoginService'
];

module.exports = LoginFormController;



// WEBPACK FOOTER //
// ./src/app/login/loginForm/LoginFormController.js